var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRelease4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 153,
    viewBox: "0 0 191 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.021,
    width: 87.9792,
    height: 70.3834,
    rx: 16,
    fill: "#42B2FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.329,
    cy: 36.3269,
    r: 35.4755,
    fill: "#FDCB6E"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 82.0193,
    width: 87.9792,
    height: 70.3834,
    rx: 16,
    fill: "#12B1B4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelease4);
export default __webpack_public_path__ + "static/media/release-4.e3a9bb319172b0e3a762bbab287c72ec.svg";
export { ForwardRef as ReactComponent };